export default {
  'list-title': 'ミッション一覧',
  'create-title': 'ミッション作成',
  'edit-title': 'ミッション編集',
  'detail-title': 'ミッション詳細',
  'create-button': '作成',
  'update-button': '更新',
  'edit-button': '編集',
  'hidden-button': '非表示',
  'redisplay-button': '再表示',
  'cancel-button': 'キャンセル',
  'selection-button': '選択',
  'all-missions': '全てのミッション',
  'my-missions': '自分の担当ミッション',
  'hidden-mission': '非表示中のミッション',
  'form': {
    'placeholder': {
      'mission-name': 'ミッション名',
      'mission-date': '実施日',
      'location-lat': '緯度',
      'location-lng': '経度',
      'now-data': '今日',
      'pilot-name': 'パイロット名',
    },
    'select-text': 'の選択...',
  },
  'error-message': {
    'select-pilot': 'パイロットを選択してください',
    'enter-mission-name': 'ミッション名を入力してください',
    'enter-implementation-date': '実施日を入力してください',
    'create-update-failed': '作成・更新に失敗しました',
    'some-itmes-failed': '正しく接続出来ていない項目があります。メッセージをご確認下さい。',
    'device-error': 'カメラとモバイルデバイスが正しく接続されているかご確認下さい。',
    'get-device-id-failed': 'デバイスIDの取得に失敗しました。',
    'get-device-region-failed': 'リージョンの取得に失敗しました。',
    'get-live-view-info-failed': 'ライブビュー情報の取得に失敗しました。HDMIケーブルが接続されているかご確認ください。',
    'start-live-view-failed': 'ライブビューの開始に失敗しました。',
    'take-photo-failed': '撮影に失敗しました。',
  },
  'label': {
    'mission-name': 'ミッション名',
    'status': 'ステータス',
    'implementation-date': '実施日',
  },
  'detail': {
    'mission-name': 'ミッション名',
    'mission-date': '実施日',
    'pilot-name': 'パイロット名',
    'location-lat': '緯度',
    'location-lng': '経度',
    'status': 'ステータス',
    'flight-info': {
      'flight-title': 'フライト情報',
      'timestamp': 'タイムスタンプ',
      'Location': {
        'Location': '位置情報',
        'gps': 'GPS',
        'rtk': 'RTK',
      },
      'direction': '方向',
      'networkType': 'ネットワークタイプ',
      'flightStatus': 'フライトステータス',
      'rfStrength': '無線周波数',
      'cellInfo': 'セル情報',
      'flightTime': '飛行時間',
      'Battery': {
        'Battery': 'バッテリー',
        'drone': 'ドローン',
        'camera': 'カメラ',
        'android': 'Android',
      },
      'beacon': 'ビーコン',
      'applicationStatus': 'アプリケーションステータス',
      'android': {
        'android': 'Android',
        'SysTemp': 'システム',
        'FanOutput': 'ファン出力',
      },
      'DiskSpace': {
        'DiskSpace': 'ディスク容量',
        'camera': 'カメラ',
        'android': 'Android',
      },
      'statusCode': 'ステータスコード',
      'currTimeDiff': '現在時刻との差分',
      'hdmiConnection': 'HDMI接続',
      'hdmiConnectionStatusConnected': '接続されています',
      'hdmiConnectionStatusDisconnected': '接続されていません',
      'cameraUsbConnection': 'カメラのUSB接続',
      'cameraUsbConnectionStatusConnected': '接続されています',
      'cameraUsbConnectionStatusDisconnected': '接続されていません',
    },
    'img-info': {
      'img-title': '写真',
      'modal-close': 'Close',
      'thumbnail-img': 'のサムネイル画像',
      'original-img': 'のオリジナル画像',
    },
    'live-view': {
      'live-view-title': 'ライブビュー',
      'start-button': 'ストリーミングを開始',
      'stop-button': 'ストリーミングを停止',
    },
    'device': {
      'device-title': 'デバイス',
      'device-id': 'デバイス ID',
      'region': 'リージョン',
    },
  },
  'status': {
    'planned': '予定',
    'ongoing': '進行中',
    'finished': '終了',
    'abondon': '放棄',
  },
}
